import Vue from "vue";
import Router from "vue-router";

const Index = () => import("views/oa/");
//首页
const Home = () => import("views/oa/home/");
// const DataState = () => import("views/oa/home/data-state/DataState");
const OperateIndex = () => import("views/oa/home/operate/index.vue");
const Operate = () => import("views/oa/home/operate/Operate.vue");
const CustomerSingleReport = () => import("views/oa/home/operate/CustomerSingleReport.vue");
const CustomerProductionDataIndex = () => import("views/oa/home/production-data/index.vue");
const CustomerShipmentData = () => import("views/oa/home/production-data/shipment-data/ShipmentData.vue");
const CustomerAfterSale = () => import("views/oa/home/production-data/after-sale/after-sale.vue");
const DataReportIndex = () => import("views/oa/home/data-report/index.vue");
const WarehouseDimension = () => import("views/oa/home/data-report/warehouse-dimension/warehouse-dimension.vue");
const CustomerDimension = () => import("views/oa/home/data-report/customer-dimension/customer-dimension.vue");
//数据导入
const DataImport = () => import("views/oa/data-import/");
const StepGuide = () => import("views/oa/data-import/step-guide/StepGuide");
const WmsOrder = () => import("views/oa/data-import/wms/WmsOrder");
const RentalIncome = () =>
  import("views/oa/data-import/rental-income/RentalIncome");
const OtherIncome = () => import("views/oa/data-import/other-income/OtherIncome");
const Expenses = () => import("views/oa/data-import/expenses/Expenses");
/* const IncomeExpenditure = () =>
  import("views/oa/data-import/income-expenditure/IncomeExpenditure"); */
// 拦截入库列表
const InterceptWarehousing = () => import("views/oa/data-import/other-expenses/intercept-warehousing");
// 收货数据
const ReceivingData = () => import("views/oa/data-import/receiving-data/receiving-data.vue");
// 单量录入
const SingleQuantityEntry = () => import("views/oa/data-import/single-quantity-entry/single-quantity-entry.vue");
// 人工成本
const LaborCost = () => import("views/oa/data-import/labor-cost/labor-cost.vue");
// 盘点
const Inventory = () => import("views/oa/data-import/Inventory/Inventory.vue");
// 过期产品录入
const ExpiredProducts = () => import("views/oa/data-import/expired-products/expired-products.vue");
// 储位管理
const StorageManagement = () => import("views/oa/data-import/storage-management/storage-management.vue");
// 异常订单
const AbnormalOrder = () => import("views/oa/data-import/abnormal-order/abnormal-order.vue");
// 市内配送
const LocalDistribution = () => import("views/oa/data-import/local-distribution/local-distribution.vue");

//成本计算
const Cost = () => import("views/oa/cost/Cost");

//基础信息
const BaseInfoIndex = () => import("views/oa/base-info/");
//项目管理
const ProjectManageIndex = () => import("views/oa/base-info/project-manage/");
const ProjectListIndex = () => import("views/oa/base-info/project-manage/project-list/");
const ProjectManage = () => import("views/oa/base-info/project-manage/project-list/ProjectManage.vue");
const addProject = () => import("views/oa/base-info/project-manage/project-list/addProject");
const CustomerList = () => import("views/oa/base-info/project-manage/Customer-list.vue");
//仓库管理
const WarehouseManage = () => import("views/oa/base-info/WarehouseManage");
const GoodsInfo = () => import("views/oa/base-info/goodsInfo.vue");
//承运商管理
const CarrierIndex = () => import("views/oa/base-info/carrier/");
const CarrierArchives = () => import("views/oa/base-info/carrier/Carrier.vue");
//客户快递规则
const Logistics = () => import("views/oa/base-info/carrier/logistics/");
const LogisticsList = () =>
  import("views/oa/base-info/carrier/logistics/LogisticsList");
const LogisticsDetail = () =>
  import("views/oa/base-info/carrier/logistics/LogisticsDetail");
const AddLogistics = () => import("views/oa/base-info/carrier/logistics/AddLogistics");
//承运商快递规则
const Express = () => import("views/oa/base-info/carrier/express-inquiry/");
const ExpressInquiry = () =>
  import("views/oa/base-info/carrier/express-inquiry/ExpressInquiry");
const AddExpress = () =>
  import("views/oa/base-info/carrier/express-inquiry/AddExpress");
const ExpressDetail = () =>
  import("views/oa/base-info/carrier/express-inquiry/ExpressDetail");
// 成本信息
  const CostInfo = () =>
    import("views/oa/base-info/cost-info.vue");

// 服务
const ServiceIndex = () => import("views/oa/service/");
const ChargeIndex = () =>
  import("views/oa/service/charge-register/index");
const ChargeRegister = () =>
  import("views/oa/service/charge-register/ChargeRegister");
const ChargeRecord = () =>
  import("views/oa/service/charge-register/ChargeRecord");
const ClaimIndex = () =>
  import("views/oa/service/claim-demage/index");
const ClaimRegister = () =>
  import("views/oa/service/claim-demage/claim-register");
const ChargeTBCRecord = () =>
  import("views/oa/service/claim-demage/tbc-record.vue");
const ChargeConfirmedRecord = () =>
  import("views/oa/service/claim-demage/confirmed-record.vue");
const ReturnRegisterIndex = () =>
  import("views/oa/service/return-register/index.vue");
const ReturnRegister = () =>
  import("views/oa/service/return-register/return-register.vue");

// 考勤
const AttendanceIndex = () => import("views/oa/attendance/");
//员工管理
const Employee = () => import("views/oa/employee/");
const EmployeeOrganization = () => import("views/oa/employee/organization/");
const Organization = () => import("views/oa/employee/organization/Organization");
const EmployeeSetting = () =>
  import("views/oa/employee/organization/EmployeeSetting");
const RuleSetting = () =>
  import("views/oa/employee/organization/RuleSetting");
const SalaryManagement = () =>
  import("views/oa/employee/salary-management/SalaryManagement");
const AttendanceSetting = () =>
  import("views/oa/employee/attendance-setting/AttendanceSetting");
const OvertimeRules = () =>
  import("views/oa/employee/overtime-rules/OvertimeRules");
const TemporaryClock = () => import("views/oa/employee/temporary-clock/TemporaryClock");
// 员工费用
const StaffCostsIndex = () => import("views/oa/attendance/staff-costs/");
const Personnel = () => import("views/oa/attendance/staff-costs/personnel-pay/");
const PersonnelPay = () =>
  import("views/oa/attendance/staff-costs/personnel-pay/PersonnelPay");
const TemporaryPay = () =>
  import("views/oa/attendance/staff-costs/temporary-pay/TemporaryPay");

//系统设置
const SystemSettingsIndex = () => import("views/oa/system-settings/");
//用户管理(index)
const UserManage = () => import("views/oa/system-settings/user-manage/");
const UserList = () => import("views/oa/system-settings/user-manage/UserManage");
const UserAuthority = () => import("views/oa/system-settings/user-manage/UserAuthority");

const Login = () => import("views/oa/login/Login");
const BigScreen = () => import("views/oa/big-screen/BigScreen");

// 财务
const FinanceIndex = () => import("views/oa/finance/");
// 客户对账(index)
const FinancialReconciliation = () => import("views/oa/finance/financial-reconciliation/");
const FinancialReconciliationList = () => import("views/oa/finance/financial-reconciliation/FinancialReconciliation");
const BillDetails = () => import("views/oa/finance/financial-reconciliation/BillDetails");
// 承运商对账（index）
const CarrierReconciliation = () => import("views/oa/finance/carrier-reconciliation/");
const CarrierReconciliationList = () => import("views/oa/finance/carrier-reconciliation/CarrierReconcliation.vue");
// 快递费用计算
const costCalculationIndex = () => import("views/oa/finance/cost-calculation/");
const costCalculation = () => import("views/oa/finance/cost-calculation/calculation");
// 物流数据核验
const logisticsVerificationIndex = () => import("views/oa/finance/logistics-verification/");
const logisticsVerification = () => import("views/oa/finance/logistics-verification/logistics-verification.vue");

// 信鸽货主端登录页
const CursomersLogin = () => import("views/customers/login/login.vue");
const CursomersIndex = () => import("views/customers/");
const CursomersOrderSearch = () => import("views/customers/order-search/order-search.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Index,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: Home,
          redirect: "/home/data-report",
          meta: {
            menuName: "数据中心"
          },
          children: [
            // {
            //   path: "data-state",
            //   name: "data-state",
            //   component: DataState,
            //   meta: {
            //     menuName: "数据发布"
            //   }
            // },
            {
              path: "data-report",
              name: "data-report",
              component: DataReportIndex,
              redirect: "/home/data-report/warehouseDimension",
              meta: {
                menuName: "数据报告"
              },
              children: [
                {
                  path: "warehouseDimension",
                  name: "warehouseDimension",
                  component: WarehouseDimension,
                  meta: {
                    menuName: "仓库维度",
                  },
                },
                {
                  path: "customerDimension",
                  name: "customerDimension",
                  component: CustomerDimension,
                  meta: {
                    menuName: "客户维度",
                  },
                }
              ]
            },
            {
              path: "operateIndex",
              name: "operateIndex",
              component: OperateIndex,
              redirect: "/home/operateIndex/operate",
              meta: {
                menuName: "运营数据",
              },
              children: [
                {
                  path: "operate",
                  name: "operate",
                  component: Operate,
                  meta: {
                    menuName: "仓库日报",
                    keepAlive: true
                  },
                },
                {
                  path: "customerSingleReport",
                  name: "customerSingleReport",
                  component: CustomerSingleReport,
                  meta: {
                    menuName: "客户单报"
                  },
                },
              ]
            },
            {
              path: "production-data",
              name: "production-data",
              component: CustomerProductionDataIndex,
              redirect: "/home/production-data/shipment-data",
              children: [
                {
                  path: "shipment-data",
                  name: "shipment-data",
                  component: CustomerShipmentData,
                  meta: {
                    menuName: "发货数据"
                  }
                },
                {
                  path: "after-sale",
                  name: "after-sale",
                  component: CustomerAfterSale,
                  meta: {
                    menuName: "售后数据"
                  }
                }
              ]
            },
          ]
        },
        {
          path: "/data-import",
          name: "/data-import",
          component: DataImport,
          redirect: "/data-import/step-guide",
          meta: {
            menuName: "数据导入"
          },
          children: [
            {
              path: "step-guide",
              name: "step-guide",
              component: StepGuide,
              meta: {
                menuName: "步骤指南"
              }
            },
            {
              path: "wms-order",
              name: "wms-order",
              component: WmsOrder,
              meta: {
                menuName: "异常修正"
              }
            },
            {
              path: "rental-income",
              name: "rental-income",
              component: RentalIncome,
              meta: {
                menuName: "场地面积录入"
              }
            },
            {
              path: "other-income",
              name: "other-income",
              component: OtherIncome,
              meta: {
                menuName: "其他收入"
              }
            },
            {
              path: "expenses",
              name: "expenses",
              component: Expenses,
              meta: {
                menuName: "相关费用"
              }
            },
            /* {
              path: "income-expenditure",
              name: "income-expenditure",
              component: IncomeExpenditure,
              meta: {
                menuName: "实际快递"
              }
            }, */
            {
              path: "intercept-warehousing",
              name: "intercept-warehousing",
              component: InterceptWarehousing,
              meta: {
                menuName: "拦截入库列表"
              }
            },

            {
              path: "receiving-data",
              name: "receiving-data",
              component: ReceivingData,
              meta: {
                menuName: "收货数据"
              }
            },
            {
              path: "single-quantity",
              name: "single-quantity",
              component: SingleQuantityEntry,
              meta: {
                menuName: "单量录入"
              }
            },
            {
              path: "labor-cost",
              name: "labor-cost",
              component: LaborCost,
              meta: {
                menuName: "人工成本"
              }
            },
            {
              path: "inventory",
              name: "inventory",
              component: Inventory,
              meta: {
                menuName: "盘点"
              }
            },
            {
              path: "expired-products",
              name: "expired-products",
              component: ExpiredProducts,
              meta: {
                menuName: "过期产品录入"
              }
            },
            {
              path: "storage-management",
              name: "storage-management",
              component: StorageManagement,
              meta: {
                menuName: "储位管理"
              }
            },
            {
              path: "abnormal-order",
              name: "abnormal-order",
              component: AbnormalOrder,
              meta: {
                menuName: "异常订单"
              }
            },
            {
              path: "local-distribution",
              name: "local-distribution",
              component: LocalDistribution,
              meta: {
                menuName: "市内配送"
              }
            }
          ]
        },
        {
          path: "/cost",
          name: "/cost",
          component: Cost,
          meta: {
            menuName: "成本计算"
          }
        },
        {
          path: "/base-info",
          name: "/base-info",
          component: BaseInfoIndex,
          redirect: "/base-info/project-manage",
          meta: {
            menuName: "基础信息"
          },
          children: [
            {
              path: "project-manage",
              name: "project-manage",
              component: ProjectManageIndex,
              redirect: "/base-info/project-manage/customer-list",
              meta: {
                menuName: "项目管理"
              },
              children: [
                {
                  path: "customer-list",
                  name: "customer-list",
                  component: CustomerList,
                  meta: {
                    menuName: "客户列表"
                  },
                },
                {
                  path: "project-list",
                  name: "project-list",
                  component: ProjectListIndex,
                  redirect: "/base-info/project-manage/project-list/project-manage-list",
                  meta: {
                    menuName: "项目列表"
                  },
                  children: [
                    {
                      path: "project-manage-list",
                      name: "project-manage-list",
                      component: ProjectManage,
                    },
                    {
                      path: "add-project",
                      name: "add-project",
                      component: addProject,
                      meta: {
                        menuName: "新增项目"
                      },
                    },
                  ]
                },
              ]
            },
            {
              path: "warehouse-manage",
              name: "warehouse-manage",
              component: WarehouseManage,
              meta: {
                menuName: "仓库管理"
              }
            },
            {
              path: "carrier",
              name: "carrier",
              component: CarrierIndex,
              redirect: "/base-info/carrier/carrier-archives",
              meta: {
                menuName: "物流维护"
              },
              children: [
                {
                  path: "carrier-archives",
                  name: "carrier-archives",
                  component: CarrierArchives,
                  meta: {
                    menuName: "物流匹配规则"
                  }
                },
                {
                  path: "logistics",
                  name: "logistics",
                  component: Logistics,
                  redirect: "/base-info/carrier/logistics/logistics-list",
                  meta: {
                    menuName: "客户快递规则"
                  },
                  children: [
                    {
                      path: "logistics-list",
                      name: "logistics-list",
                      component: LogisticsList
                    },
                    {
                      path: "logistics-detail",
                      name: "logistics-detail",
                      component: LogisticsDetail,
                      meta: {
                        menuName: "规则详情"
                      }
                    },
                    {
                      path: "add-logistics",
                      name: "add-logistics",
                      component: AddLogistics,
                      meta: {
                        menuName: "添加规则"
                      }
                    }
                  ]
                },
                {
                  path: "express",
                  name: "express",
                  component: Express,
                  meta: {
                    menuName: "承运商快递规则"
                  },
                  redirect: "/base-info/carrier/express/express-inquiry",
                  children: [
                    {
                      path: "express-inquiry",
                      name: "express-inquiry",
                      component: ExpressInquiry
                    },
                    {
                      path: "add-express",
                      name: "add-express",
                      component: AddExpress,
                      meta: {
                        menuName: "新增快递"
                      }
                    },
                    {
                      path: "express-detail",
                      name: "express-detail",
                      component: ExpressDetail,
                      meta: {
                        menuName: "快递详情"
                      }
                    }
                  ]
                },
              ]
            },
            {
              path: "goods-info",
              name: "goods-info",
              component: GoodsInfo,
              meta: {
                menuName: "商品信息"
              }
            },
            {
              path: "cost-info",
              name: "cost-info",
              component: CostInfo,
              meta: {
                menuName: "成本信息"
              }
            },
          ]
        },
        {
          path: "/system-settings",
          name: "/system-settings",
          component: SystemSettingsIndex,
          redirect: "/system-settings/user-manage",
          meta: {
            menuName: "系统设置"
          },
          children: [
            {
              path: "user-manage",
              name: "user-manage",
              component: UserManage,
              redirect: "/system-settings/user-manage/user-list",
              children: [
                {
                  path: "user-list",
                  name: "user-list",
                  component: UserList,
                  meta: {
                    menuName: "用户管理"
                  },
                },
                {
                  path: "user-authority",
                  name: "user-authority",
                  component: UserAuthority,
                  meta: {
                    menuName: "用户权限"
                  }
                }
              ]
            },
          ]
        },
        {
          path: "/finance",
          name: "finance",
          component: FinanceIndex,
          redirect: "/finance/financial-reconciliation",
          meta: {
            menuName: "财务"
          },
          children: [
            {
              path: "financial-reconciliation",
              name: "financial-reconciliation",
              component: FinancialReconciliation,
              redirect: "/finance/financial-reconciliation/financial-reconciliation-list",
              children: [
                {
                  path: "financial-reconciliation-list",
                  name: "financial-reconciliation-list",
                  component: FinancialReconciliationList,
                  meta: {
                    menuName: "客户对账"
                  },
                },
                {
                  path: "bill-details",
                  name: "bill-details",
                  component: BillDetails,
                  meta: {
                    menuName: "账单详情"
                  },
                }
              ]
            },
            {
              path: "carrier-reconciliation",
              name: "carrier-reconciliation",
              component: CarrierReconciliation,
              redirect: "/finance/carrier-reconciliation/carrier-reconciliation-list",
              meta: {
                menuName: "承运商对账"
              },
              children: [
                {
                  path: "carrier-reconciliation-list",
                  name: "carrier-reconciliation-list",
                  component: CarrierReconciliationList,
                },
              ]
            },
            {
              path: 'cost-calculation',
              name: "cost-calculation",
              component: costCalculationIndex,
              redirect: "/finance/cost-calculation/calculation",
              children: [
                {
                  path: 'calculation',
                  name: "calculation",
                  component: costCalculation,
                  meta: {
                    menuName: "快递费用计算"
                  },
                }
              ]
            },
            {
              path: 'logistics-verification',
              name: "logistics-verification",
              component: logisticsVerificationIndex,
              redirect: "/finance/logistics-verification/logistics-verification-list",
              children: [
                {
                  path: 'logistics-verification-list',
                  name: "logistics-verification-list",
                  component: logisticsVerification,
                  meta: {
                    menuName: "物流数据核验"
                  },
                }
              ]
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: ServiceIndex,
          redirect: "/service/charge-index",
          meta: {
            menuName: "服务"
          },
          children: [
            {
              path: "charge-index",
              name: "charge-index",
              component: ChargeIndex,
              redirect: "/service/charge-index/charge-register",
              children: [
                {
                  path: "charge-register",
                  name: "charge-register",
                  component: ChargeRegister,
                  meta: {
                    menuName: "收费登记"
                  }
                },
                {
                  path: "charge-record",
                  name: "charge-record",
                  component: ChargeRecord,
                  meta: {
                    menuName: "收费记录"
                  }
                },
              ]
            },
            {
              path: "claim-index",
              name: "claim-index",
              component: ClaimIndex,
              redirect: "/service/claim-index/claim-register",
              children: [
                {
                  path: "claim-register",
                  name: "claim-register",
                  component: ClaimRegister,
                  meta: {
                    menuName: "索赔登记"
                  }
                },
                {
                  path: "tbc-record",
                  name: "tbc-record",
                  component: ChargeTBCRecord,
                  meta: {
                    menuName: "待确认表单"
                  }
                },
                {
                  path: "confirmed-record",
                  name: "confirmed-record",
                  component: ChargeConfirmedRecord,
                  meta: {
                    menuName: "已确认表单"
                  }
                },
              ]
            },
            {
              path: "return-index",
              name: "return-index",
              component: ReturnRegisterIndex,
              redirect: "/service/return-index/return-register",
              children: [
                {
                  path: "return-register",
                  name: "return-register",
                  component: ReturnRegister,
                  meta: {
                    menuName: "退货登记"
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/attendance",
          name: "attendance",
          component: AttendanceIndex,
          redirect: "/attendance/employee",
          meta: {
            menuName: "考勤"
          },
          children: [
            {
              path: "employee",
              name: "employee",
              component: Employee,
              redirect: "/attendance/employee/employee-organization",
              meta: {
                menuName: "员工管理"
              },
              children: [
                {
                  path: "employee-organization",
                  name: "employee-organization",
                  component: EmployeeOrganization,
                  redirect: "/attendance/employee/employee-organization/organization",
                  meta: {
                    menuName: "组织架构"
                  },
                  children: [
                    {
                      path: "organization",
                      name: "organization",
                      component: Organization
                    },
                    {
                      path: "employee-setting",
                      name: "employee-setting",
                      component: EmployeeSetting,
                      meta: {
                        menuName: "权限设置"
                      }
                    },
                    {
                      path: "rule-setting",
                      name: "rule-setting",
                      component: RuleSetting,
                      meta: {
                        menuName: "员工成本计算规则"
                      }
                    }
                  ]
                },
                {
                  path: "salary-management",
                  name: "salary-management",
                  component: SalaryManagement,
                  meta: {
                    menuName: "薪资管理"
                  }
                },
                {
                  path: "attendance-setting",
                  name: "attendance-setting",
                  component: AttendanceSetting,
                  meta: {
                    menuName: "出勤设置"
                  }
                },
                {
                  path: "overtime-rules",
                  name: "overtime-rules",
                  component: OvertimeRules,
                  meta: {
                    menuName: "加班规则"
                  }
                },
                {
                  path: "temporary-clock",
                  name: "temporary-clock",
                  component: TemporaryClock,
                  meta: {
                    menuName: "临时工打卡"
                  }
                }
              ]
            },
            {
              path: "staffCosts",
              name: "staffCosts",
              component: StaffCostsIndex,
              redirect: "/attendance/staffCosts/personnel",
              meta: {
                menuName: "员工费用"
              },
              children: [
                {
                  path: "personnel",
                  name: "personnel",
                  component: Personnel,
                  redirect: "/attendance/staffCosts/personnel/personnel-pay",
                  meta: {
                    menuName: "人员支出"
                  },
                  children: [
                    {
                      path: "personnel-pay",
                      name: "personnel-pay",
                      component: PersonnelPay
                    },
                  ]
                },
                {
                  path: "temporary-pay",
                  name: "temporary-pay",
                  component: TemporaryPay,
                  meta: {
                    menuName: "临时工支出"
                  }
                },
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/big-screen",
      component: BigScreen
    },
    {
      // 信鸽货主端登录页面
      path: '/customers-login',
      component: CursomersLogin
    },
    {
      path: '/customers',
      component: CursomersIndex,
      redirect: '/customers/order-search',
      children: [
        {
          path: 'order-search',
          name: 'order-search',
          component: CursomersOrderSearch,
          meta: { title: '订单查询' },
        }
      ]
    },
  ]
});

router.afterEach((to) => {
  if (to.path === '/project-manage/add-project') {
    if (to.query.isFlag == 1) {
      to.meta.menuName = '新增'
    } else if (to.query.isFlag == 2) {
      to.meta.menuName = '编辑'
    } else if (to.query.isFlag == 3) {
      to.meta.menuName = '详情'
    }
  }
  // if (document.getElementById("pageContent")) {
  //   document.getElementById("pageContent").scrollTop = 0;
  // }
});

export default router;
